import React, { useMemo } from 'react'
import { useSelector } from 'react-redux';
import TokenDataContainer from './TokenDataContainer';

const DeployTokenCard = React.forwardRef(({ token, isTokenDeployed, tokenData, selectedTokenId, index, setSelectedTokenId, isEditingCurrentToken, setShowUnsavedChangesModal, setNextTokenId, hasUnsavedChanges, canvasRef }, ref) => {
    // get current season details
    const { currentSeason } = useSelector((state) => state.seasons); 
    const actions = currentSeason?.actions;                           // get current season actions
    const players = currentSeason?.homeTeam?.players;                 // get current season players
    // to check current token deployed or not
    const _isCurrentDeployed = isTokenDeployed(index);
    const isCurrentDeployed = isEditingCurrentToken ? false : _isCurrentDeployed;

    // selected player image
    const playerImage = useMemo(() => {
      if (isCurrentDeployed) {
        const deployedPlayer = players.find((player) => player.playerId === isCurrentDeployed?.deployedPlayerId);
        return {
          src: deployedPlayer?.profilePic,
          alt: deployedPlayer?.playerName,
          text: deployedPlayer?.playerName,
          id: deployedPlayer?.playerId
        };
      } else {
        return tokenData.find((token) => token.tokenIndex === index)?.selectedImages?.playerImage;
      }
    }, [isCurrentDeployed, players, tokenData, selectedTokenId]);

    // selected action image
    const actionImage = useMemo(() => {
      if (isCurrentDeployed) {
        const deployedAction = actions.find((action) => action.actionName === isCurrentDeployed?.deployedActionName);
        return {
            src: deployedAction?.actionImage,
            alt: deployedAction?.actionName,
            text: deployedAction?.actionName,
            id: deployedAction?.actionName, // for actions actionName is there id
        };
      } else {
        return tokenData.find((token) => token.tokenIndex === index)?.selectedImages?.actionImage;
      }
    }, [isCurrentDeployed, actions, tokenData, selectedTokenId]);


    const handleTokenSelect = () => {
      if (hasUnsavedChanges && selectedTokenId !== index) {
        setShowUnsavedChangesModal(true); // Show modal before switching
        setNextTokenId(index); // Store the token to switch to
      } else {
          setSelectedTokenId(index);
      }
  };
  

    return (
      <TokenDataContainer
        tokenNumber={token?.tokenName?.split('-')?.length > 0 ? token?.tokenName?.split('-')[token?.tokenName?.split('-')?.length - 1] : ""} 
        zoneCategory={token?.zoneCategoryName} 
        actionImage={actionImage}  
        playerImage={playerImage} 
        isSelected={selectedTokenId === index}
        isCurrentDeployed={isCurrentDeployed} 
        onClick={handleTokenSelect} 
        ref={ref} // ref is passed for autoscroll functionality
        zoneNumber={token?.zoneName}
        canvasRef={canvasRef}
        deployedImage={_isCurrentDeployed?.deployedTokenImage}
      />
    );
});

DeployTokenCard.displayName = "DeployTokenCard";

export default DeployTokenCard